/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeatureitemsorting3Inputs */

const en_aifeatureitemsorting3 = /** @type {(inputs: Aifeatureitemsorting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorting events and places`)
};

const de_aifeatureitemsorting3 = /** @type {(inputs: Aifeatureitemsorting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events und Orte sortieren`)
};

/**
* | output |
* | --- |
* | "Sorting events and places" |
*
* @param {Aifeatureitemsorting3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeatureitemsorting3 = /** @type {((inputs?: Aifeatureitemsorting3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeatureitemsorting3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeatureitemsorting3(inputs)
	return de_aifeatureitemsorting3(inputs)
});
export { aifeatureitemsorting3 as "aiFeatureItemSorting" }